// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ConfirmationModal__base___2m9lX{position:fixed;z-index:9999;top:0;left:0;width:100%;height:100%}.ConfirmationModal__content___jGApw{position:relative;z-index:1;width:350px;max-width:100%;margin:15% auto;padding:20px;background-color:#fff;border-radius:10px;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.33);box-shadow:0 2px 8px rgba(0,0,0,.33)}.ConfirmationModal__background___-BqQL{position:absolute;left:0;top:0;width:100%;height:100%;background-color:rgba(0,0,0,.5)}.ConfirmationModal__buttons___20iFE{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:20px}.ConfirmationModal__buttons___20iFE>*{margin-left:10px}", ""]);
// Exports
exports.locals = {
	"base": "ConfirmationModal__base___2m9lX",
	"content": "ConfirmationModal__content___jGApw",
	"background": "ConfirmationModal__background___-BqQL",
	"buttons": "ConfirmationModal__buttons___20iFE"
};
module.exports = exports;
